import { render, staticRenderFns } from "./dealercomstatistics.vue?vue&type=template&id=00f7f244&"
import script from "./dealercomstatistics.vue?vue&type=script&lang=js&"
export * from "./dealercomstatistics.vue?vue&type=script&lang=js&"
import style0 from "./dealercomstatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports